import CustomChip from '../../../components/CustomChip';
import { useLanguage } from '../../../contexts/language';
import { BADGE_CLASSNAMES } from '../../../utils/styles';

export interface OperatorBadgeProps {
  isVisible: boolean;
  small?: boolean;
}

const IslandVisibilityBadge = ({ isVisible, small }: OperatorBadgeProps) => {
  const { t } = useLanguage();
  return (
    <CustomChip
      label={t(`content.${isVisible ? 'visible' : 'hidden'}`)}
      small={small}
      className={isVisible ? BADGE_CLASSNAMES.GREEN : BADGE_CLASSNAMES.RED}
    />
  );
};

export default IslandVisibilityBadge;
